import { SUCCESS } from "../../../../../constants/action-postfix";
import { PERFORMANCE_REQUEST } from "../../performanceReducer";


const initialState = null;

export const summaryReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${PERFORMANCE_REQUEST}${SUCCESS}`:
            return action.payload.summary;
        default:
            return state;
    }
};
